export default "__VITE_ASSET__301d6003__"